/**
 * NL-geometrie (lon/lat, WGS84) voor de radar-basiskaart: vasteland + Zeeuwse eilanden +
 * de **Waddeneilanden** (los) als land, en het **IJsselmeer/Markermeer** + enkele meren als
 * water. Twee afnemers her-projecteren naar EPSG:3857 zodat alles op de KNMI-WMS-frames ligt:
 * de radar-island (`site/islands/radar.ts`, canvas) en de no-JS-basiskaart
 * (`view-v2/components/radar-basemap.ts`, SSR-SVG).
 *
 * bron: Natural Earth 10m (public domain) — `ne_10m_admin_0_countries` (NL-omtrek + eilanden)
 * + `ne_10m_lakes`/`ne_10m_lakes_europe` (meren), geclipt op NL, afgerond op 3 decimalen.
 * Puur weergavedata; geen runtime-call, geen map-bibliotheek (§2).
 */

export type GeoRing = ReadonlyArray<readonly [number, number]>;

/** Landvlakken (vasteland + eilanden) — gevuld + omtrek gestroked. */
export const NL_LAND: ReadonlyArray<GeoRing> = [
  [
    [6.867, 53.434],
    [6.901, 53.352],
    [6.906, 53.35],
    [6.93, 53.34],
    [6.932, 53.338],
    [6.937, 53.335],
    [6.942, 53.331],
    [6.949, 53.326],
    [6.98, 53.32],
    [7.02, 53.306],
    [7.038, 53.31],
    [7.046, 53.304],
    [7.058, 53.302],
    [7.07, 53.304],
    [7.079, 53.31],
    [7.085, 53.31],
    [7.085, 53.303],
    [7.077, 53.299],
    [7.073, 53.296],
    [7.074, 53.291],
    [7.079, 53.283],
    [7.081, 53.267],
    [7.111, 53.256],
    [7.183, 53.245],
    [7.195, 53.245],
    [7.197, 53.217],
    [7.199, 53.201],
    [7.195, 53.185],
    [7.189, 53.168],
    [7.174, 53.146],
    [7.172, 53.138],
    [7.173, 53.126],
    [7.176, 53.119],
    [7.181, 53.114],
    [7.185, 53.105],
    [7.194, 53.034],
    [7.193, 52.998],
    [7.184, 52.966],
    [7.162, 52.933],
    [7.08, 52.854],
    [7.072, 52.841],
    [7.062, 52.824],
    [7.053, 52.791],
    [7.044, 52.683],
    [7.037, 52.647],
    [7.018, 52.626],
    [6.983, 52.633],
    [6.968, 52.637],
    [6.918, 52.632],
    [6.865, 52.642],
    [6.771, 52.641],
    [6.737, 52.635],
    [6.719, 52.627],
    [6.702, 52.619],
    [6.71, 52.609],
    [6.708, 52.6],
    [6.704, 52.591],
    [6.704, 52.583],
    [6.711, 52.577],
    [6.744, 52.56],
    [6.688, 52.543],
    [6.672, 52.542],
    [6.684, 52.526],
    [6.688, 52.508],
    [6.689, 52.491],
    [6.695, 52.476],
    [6.715, 52.462],
    [6.741, 52.454],
    [6.82, 52.447],
    [6.872, 52.435],
    [6.9, 52.432],
    [6.926, 52.433],
    [6.951, 52.437],
    [6.961, 52.443],
    [6.967, 52.45],
    [6.973, 52.451],
    [7.034, 52.391],
    [7.048, 52.365],
    [7.04, 52.329],
    [7.02, 52.3],
    [7.012, 52.285],
    [7.012, 52.267],
    [7.021, 52.245],
    [7.027, 52.239],
    [7.029, 52.236],
    [7.026, 52.231],
    [6.982, 52.214],
    [6.971, 52.206],
    [6.948, 52.183],
    [6.928, 52.172],
    [6.885, 52.16],
    [6.865, 52.148],
    [6.843, 52.12],
    [6.831, 52.113],
    [6.772, 52.109],
    [6.766, 52.108],
    [6.75, 52.103],
    [6.733, 52.092],
    [6.728, 52.086],
    [6.719, 52.074],
    [6.711, 52.067],
    [6.699, 52.064],
    [6.689, 52.063],
    [6.68, 52.06],
    [6.673, 52.05],
    [6.675, 52.035],
    [6.691, 52.028],
    [6.713, 52.024],
    [6.778, 52.001],
    [6.804, 51.984],
    [6.809, 51.98],
    [6.812, 51.973],
    [6.811, 51.961],
    [6.806, 51.958],
    [6.798, 51.957],
    [6.79, 51.951],
    [6.767, 51.926],
    [6.744, 51.908],
    [6.717, 51.899],
    [6.628, 51.898],
    [6.529, 51.876],
    [6.479, 51.853],
    [6.463, 51.848],
    [6.443, 51.848],
    [6.378, 51.86],
    [6.387, 51.838],
    [6.382, 51.828],
    [6.345, 51.821],
    [6.342, 51.837],
    [6.326, 51.843],
    [6.287, 51.846],
    [6.283, 51.85],
    [6.272, 51.862],
    [6.265, 51.866],
    [6.256, 51.867],
    [6.225, 51.863],
    [6.191, 51.871],
    [6.159, 51.887],
    [6.127, 51.897],
    [6.093, 51.885],
    [6.105, 51.879],
    [6.143, 51.855],
    [6.156, 51.842],
    [6.14, 51.845],
    [6.116, 51.848],
    [6.084, 51.854],
    [6.043, 51.847],
    [6.029, 51.842],
    [6.008, 51.833],
    [5.989, 51.827],
    [5.948, 51.823],
    [5.931, 51.816],
    [5.928, 51.807],
    [5.951, 51.796],
    [5.964, 51.777],
    [5.962, 51.756],
    [5.946, 51.746],
    [5.94, 51.743],
    [5.939, 51.732],
    [5.949, 51.729],
    [5.978, 51.73],
    [5.99, 51.726],
    [6.012, 51.716],
    [6.022, 51.71],
    [6.009, 51.681],
    [6.031, 51.663],
    [6.099, 51.644],
    [6.088, 51.622],
    [6.082, 51.608],
    [6.086, 51.596],
    [6.153, 51.538],
    [6.193, 51.509],
    [6.2, 51.477],
    [6.205, 51.458],
    [6.202, 51.439],
    [6.194, 51.417],
    [6.193, 51.399],
    [6.208, 51.388],
    [6.202, 51.379],
    [6.199, 51.357],
    [6.194, 51.345],
    [6.184, 51.336],
    [6.158, 51.325],
    [6.148, 51.318],
    [6.097, 51.259],
    [6.075, 51.243],
    [6.065, 51.232],
    [6.057, 51.212],
    [6.054, 51.189],
    [6.061, 51.171],
    [6.084, 51.163],
    [6.134, 51.184],
    [6.157, 51.179],
    [6.149, 51.176],
    [6.126, 51.165],
    [6.147, 51.152],
    [6.132, 51.14],
    [6.075, 51.12],
    [5.983, 51.075],
    [5.969, 51.065],
    [5.95, 51.039],
    [5.938, 51.031],
    [5.92, 51.03],
    [5.906, 51.037],
    [5.894, 51.047],
    [5.88, 51.052],
    [5.852, 51.043],
    [5.858, 51.019],
    [5.874, 50.991],
    [5.875, 50.965],
    [5.888, 50.967],
    [5.914, 50.975],
    [5.928, 50.978],
    [5.942, 50.976],
    [5.968, 50.971],
    [6.004, 50.974],
    [6.006, 50.969],
    [6.0, 50.96],
    [5.996, 50.952],
    [5.997, 50.937],
    [6.0, 50.929],
    [6.008, 50.924],
    [6.031, 50.915],
    [6.064, 50.908],
    [6.062, 50.904],
    [6.057, 50.898],
    [6.055, 50.891],
    [6.063, 50.871],
    [6.063, 50.863],
    [6.057, 50.853],
    [6.046, 50.844],
    [6.023, 50.845],
    [6.009, 50.84],
    [6.0, 50.83],
    [6.001, 50.822],
    [6.004, 50.813],
    [5.998, 50.801],
    [5.984, 50.792],
    [5.969, 50.795],
    [5.973, 50.782],
    [5.981, 50.773],
    [5.991, 50.769],
    [5.997, 50.763],
    [5.995, 50.75],
    [5.975, 50.748],
    [5.902, 50.749],
    [5.891, 50.751],
    [5.88, 50.754],
    [5.793, 50.752],
    [5.783, 50.757],
    [5.762, 50.771],
    [5.752, 50.773],
    [5.744, 50.769],
    [5.733, 50.759],
    [5.728, 50.754],
    [5.717, 50.753],
    [5.707, 50.754],
    [5.688, 50.761],
    [5.699, 50.784],
    [5.7, 50.796],
    [5.685, 50.799],
    [5.663, 50.805],
    [5.657, 50.808],
    [5.641, 50.815],
    [5.624, 50.83],
    [5.622, 50.853],
    [5.694, 50.904],
    [5.706, 50.907],
    [5.718, 50.909],
    [5.722, 50.912],
    [5.735, 50.924],
    [5.753, 50.947],
    [5.764, 50.959],
    [5.754, 50.963],
    [5.745, 50.963],
    [5.722, 50.959],
    [5.762, 50.999],
    [5.778, 51.024],
    [5.764, 51.035],
    [5.766, 51.048],
    [5.771, 51.058],
    [5.78, 51.061],
    [5.791, 51.055],
    [5.799, 51.061],
    [5.804, 51.069],
    [5.812, 51.082],
    [5.809, 51.086],
    [5.807, 51.089],
    [5.805, 51.097],
    [5.816, 51.096],
    [5.827, 51.097],
    [5.837, 51.099],
    [5.846, 51.103],
    [5.823, 51.119],
    [5.826, 51.13],
    [5.841, 51.139],
    [5.838, 51.144],
    [5.829, 51.156],
    [5.812, 51.157],
    [5.781, 51.152],
    [5.768, 51.159],
    [5.747, 51.178],
    [5.731, 51.184],
    [5.718, 51.185],
    [5.676, 51.179],
    [5.659, 51.179],
    [5.648, 51.184],
    [5.639, 51.191],
    [5.625, 51.197],
    [5.568, 51.208],
    [5.551, 51.217],
    [5.546, 51.22],
    [5.542, 51.243],
    [5.535, 51.262],
    [5.517, 51.277],
    [5.493, 51.287],
    [5.472, 51.288],
    [5.452, 51.282],
    [5.41, 51.264],
    [5.389, 51.259],
    [5.271, 51.262],
    [5.239, 51.257],
    [5.233, 51.256],
    [5.215, 51.259],
    [5.215, 51.294],
    [5.197, 51.308],
    [5.179, 51.31],
    [5.14, 51.307],
    [5.123, 51.313],
    [5.118, 51.32],
    [5.108, 51.342],
    [5.103, 51.351],
    [5.068, 51.375],
    [5.062, 51.384],
    [5.065, 51.406],
    [5.076, 51.422],
    [5.08, 51.439],
    [5.06, 51.462],
    [5.03, 51.474],
    [5.028, 51.477],
    [5.012, 51.474],
    [5.006, 51.468],
    [5.003, 51.459],
    [4.996, 51.447],
    [4.98, 51.431],
    [4.957, 51.411],
    [4.932, 51.396],
    [4.91, 51.392],
    [4.872, 51.403],
    [4.853, 51.406],
    [4.783, 51.408],
    [4.762, 51.413],
    [4.768, 51.425],
    [4.779, 51.426],
    [4.823, 51.414],
    [4.815, 51.431],
    [4.82, 51.446],
    [4.826, 51.461],
    [4.824, 51.476],
    [4.814, 51.484],
    [4.797, 51.491],
    [4.779, 51.495],
    [4.764, 51.496],
    [4.731, 51.486],
    [4.654, 51.426],
    [4.644, 51.421],
    [4.63, 51.418],
    [4.615, 51.418],
    [4.583, 51.423],
    [4.554, 51.419],
    [4.541, 51.42],
    [4.522, 51.429],
    [4.523, 51.438],
    [4.532, 51.451],
    [4.533, 51.468],
    [4.525, 51.476],
    [4.513, 51.477],
    [4.483, 51.474],
    [4.429, 51.462],
    [4.377, 51.443],
    [4.389, 51.435],
    [4.387, 51.427],
    [4.381, 51.42],
    [4.38, 51.41],
    [4.388, 51.401],
    [4.41, 51.384],
    [4.416, 51.374],
    [4.411, 51.357],
    [4.392, 51.35],
    [4.346, 51.352],
    [4.326, 51.356],
    [4.29, 51.369],
    [4.281, 51.369],
    [4.261, 51.369],
    [4.257, 51.373],
    [4.249, 51.384],
    [4.246, 51.396],
    [4.247, 51.407],
    [4.245, 51.414],
    [4.235, 51.419],
    [4.223, 51.409],
    [4.201, 51.405],
    [4.111, 51.407],
    [4.09, 51.411],
    [4.07, 51.419],
    [4.015, 51.449],
    [3.999, 51.453],
    [3.957, 51.456],
    [3.943, 51.45],
    [3.913, 51.415],
    [3.902, 51.405],
    [3.887, 51.4],
    [3.851, 51.397],
    [3.838, 51.392],
    [3.827, 51.391],
    [3.816, 51.394],
    [3.789, 51.412],
    [3.729, 51.431],
    [3.69, 51.454],
    [3.674, 51.455],
    [3.633, 51.446],
    [3.61, 51.445],
    [3.553, 51.453],
    [3.535, 51.459],
    [3.52, 51.473],
    [3.507, 51.489],
    [3.495, 51.501],
    [3.462, 51.519],
    [3.451, 51.53],
    [3.447, 51.546],
    [3.458, 51.555],
    [3.56, 51.595],
    [3.829, 51.613],
    [3.851, 51.611],
    [3.866, 51.605],
    [3.882, 51.596],
    [3.896, 51.584],
    [3.906, 51.569],
    [3.895, 51.567],
    [3.878, 51.559],
    [3.872, 51.556],
    [3.872, 51.549],
    [3.967, 51.543],
    [4.016, 51.531],
    [4.057, 51.508],
    [4.07, 51.493],
    [4.09, 51.458],
    [4.105, 51.446],
    [4.129, 51.441],
    [4.181, 51.446],
    [4.2, 51.44],
    [4.22, 51.444],
    [4.253, 51.443],
    [4.264, 51.444],
    [4.283, 51.448],
    [4.297, 51.471],
    [4.289, 51.492],
    [4.268, 51.508],
    [4.24, 51.519],
    [4.23, 51.52],
    [4.195, 51.524],
    [4.153, 51.535],
    [4.138, 51.536],
    [4.106, 51.534],
    [4.091, 51.535],
    [4.067, 51.544],
    [3.988, 51.59],
    [4.041, 51.606],
    [4.068, 51.611],
    [4.157, 51.608],
    [4.183, 51.603],
    [4.207, 51.591],
    [4.207, 51.59],
    [4.203, 51.609],
    [4.19, 51.617],
    [4.186, 51.617],
    [4.147, 51.618],
    [4.136, 51.62],
    [4.126, 51.625],
    [4.118, 51.631],
    [4.113, 51.639],
    [4.11, 51.651],
    [4.11, 51.662],
    [4.113, 51.671],
    [4.126, 51.68],
    [4.143, 51.684],
    [4.177, 51.686],
    [4.166, 51.693],
    [4.141, 51.704],
    [4.072, 51.717],
    [4.057, 51.73],
    [4.051, 51.763],
    [4.034, 51.784],
    [4.01, 51.798],
    [3.981, 51.81],
    [3.963, 51.801],
    [3.937, 51.796],
    [3.911, 51.796],
    [3.892, 51.793],
    [3.888, 51.789],
    [3.881, 51.788],
    [3.872, 51.788],
    [3.862, 51.816],
    [3.891, 51.828],
    [3.954, 51.84],
    [3.963, 51.847],
    [3.982, 51.848],
    [4.016, 51.844],
    [4.043, 51.834],
    [4.048, 51.834],
    [4.055, 51.834],
    [4.065, 51.837],
    [4.078, 51.844],
    [4.07, 51.853],
    [4.045, 51.874],
    [4.038, 51.878],
    [4.032, 51.882],
    [4.03, 51.888],
    [4.032, 51.896],
    [4.037, 51.902],
    [4.041, 51.906],
    [4.043, 51.909],
    [4.04, 51.924],
    [4.021, 51.963],
    [4.01, 51.98],
    [4.016, 51.988],
    [4.022, 51.994],
    [4.069, 51.988],
    [4.108, 51.992],
    [4.142, 52.006],
    [4.285, 52.113],
    [4.407, 52.223],
    [4.508, 52.336],
    [4.569, 52.445],
    [4.577, 52.474],
    [4.577, 52.481],
    [4.597, 52.507],
    [4.639, 52.701],
    [4.657, 52.75],
    [4.66, 52.765],
    [4.669, 52.797],
    [4.712, 52.863],
    [4.721, 52.896],
    [4.722, 52.914],
    [4.726, 52.938],
    [4.734, 52.959],
    [4.745, 52.968],
    [4.807, 52.962],
    [4.817, 52.968],
    [4.824, 52.96],
    [4.809, 52.93],
    [4.833, 52.911],
    [4.874, 52.904],
    [4.913, 52.906],
    [4.936, 52.913],
    [4.978, 52.936],
    [4.999, 52.94],
    [5.039, 52.944],
    [5.078, 52.954],
    [5.279, 53.063],
    [5.294, 53.073],
    [5.313, 53.083],
    [5.359, 53.089],
    [5.379, 53.097],
    [5.4, 53.122],
    [5.427, 53.19],
    [5.447, 53.221],
    [5.483, 53.246],
    [5.504, 53.257],
    [5.541, 53.267],
    [5.558, 53.278],
    [5.573, 53.292],
    [5.592, 53.303],
    [5.612, 53.307],
    [5.66, 53.312],
    [5.695, 53.33],
    [5.855, 53.369],
    [5.891, 53.384],
    [5.914, 53.385],
    [5.981, 53.406],
    [6.077, 53.409],
    [6.186, 53.411],
    [6.274, 53.413],
    [6.284, 53.411],
    [6.302, 53.401],
    [6.312, 53.399],
    [6.32, 53.401],
    [6.346, 53.413],
    [6.494, 53.439],
    [6.73, 53.461],
    [6.829, 53.451],
    [6.85, 53.445],
    [6.867, 53.434],
  ],
  [
    [3.734, 51.356],
    [3.756, 51.35],
    [3.796, 51.35],
    [3.834, 51.343],
    [3.858, 51.345],
    [3.956, 51.372],
    [3.969, 51.382],
    [3.975, 51.402],
    [3.984, 51.41],
    [4.006, 51.41],
    [4.029, 51.404],
    [4.043, 51.399],
    [4.05, 51.392],
    [4.061, 51.377],
    [4.07, 51.371],
    [4.081, 51.368],
    [4.105, 51.366],
    [4.115, 51.361],
    [4.122, 51.359],
    [4.157, 51.358],
    [4.174, 51.374],
    [4.18, 51.377],
    [4.2, 51.376],
    [4.221, 51.368],
    [4.221, 51.364],
    [4.214, 51.341],
    [4.208, 51.331],
    [4.169, 51.297],
    [4.119, 51.272],
    [3.995, 51.233],
    [3.949, 51.211],
    [3.927, 51.206],
    [3.809, 51.205],
    [3.796, 51.209],
    [3.781, 51.22],
    [3.78, 51.23],
    [3.781, 51.241],
    [3.776, 51.255],
    [3.757, 51.262],
    [3.635, 51.288],
    [3.61, 51.29],
    [3.585, 51.29],
    [3.545, 51.284],
    [3.529, 51.283],
    [3.514, 51.281],
    [3.503, 51.274],
    [3.502, 51.262],
    [3.504, 51.25],
    [3.501, 51.24],
    [3.454, 51.236],
    [3.422, 51.238],
    [3.399, 51.245],
    [3.392, 51.247],
    [3.367, 51.263],
    [3.353, 51.289],
    [3.354, 51.312],
    [3.358, 51.337],
    [3.349, 51.375],
    [3.511, 51.408],
    [3.526, 51.416],
    [3.541, 51.417],
    [3.605, 51.391],
    [3.702, 51.374],
    [3.734, 51.356],
  ],
  [
    [4.015, 51.702],
    [4.02, 51.696],
    [4.027, 51.691],
    [4.037, 51.686],
    [4.078, 51.679],
    [4.097, 51.67],
    [4.099, 51.654],
    [4.089, 51.644],
    [4.073, 51.637],
    [4.055, 51.633],
    [3.978, 51.623],
    [3.96, 51.624],
    [3.923, 51.632],
    [3.902, 51.642],
    [3.892, 51.656],
    [3.886, 51.668],
    [3.87, 51.676],
    [3.831, 51.686],
    [3.824, 51.69],
    [3.818, 51.695],
    [3.809, 51.7],
    [3.796, 51.7],
    [3.771, 51.682],
    [3.765, 51.678],
    [3.721, 51.677],
    [3.7, 51.681],
    [3.687, 51.693],
    [3.689, 51.725],
    [3.726, 51.74],
    [3.81, 51.747],
    [3.814, 51.748],
    [3.831, 51.747],
    [3.844, 51.743],
    [3.94, 51.741],
    [3.962, 51.738],
    [3.978, 51.73],
    [4.015, 51.702],
  ],
  [
    [4.893, 53.111],
    [4.893, 53.105],
    [4.913, 53.105],
    [4.906, 53.092],
    [4.893, 53.076],
    [4.865, 53.05],
    [4.818, 53.027],
    [4.796, 53.0],
    [4.762, 52.994],
    [4.727, 53.003],
    [4.708, 53.028],
    [4.714, 53.055],
    [4.734, 53.084],
    [4.758, 53.108],
    [4.806, 53.133],
    [4.829, 53.163],
    [4.854, 53.188],
    [4.886, 53.187],
    [4.89, 53.181],
    [4.892, 53.176],
    [4.891, 53.171],
    [4.886, 53.166],
    [4.9, 53.152],
    [4.91, 53.135],
    [4.91, 53.119],
    [4.893, 53.111],
  ],
  [
    [5.427, 53.406],
    [5.382, 53.395],
    [5.347, 53.389],
    [5.208, 53.353],
    [5.18, 53.353],
    [5.168, 53.368],
    [5.179, 53.385],
    [5.232, 53.397],
    [5.25, 53.406],
    [5.273, 53.406],
    [5.407, 53.423],
    [5.424, 53.43],
    [5.437, 53.436],
    [5.585, 53.454],
    [5.562, 53.434],
    [5.534, 53.428],
    [5.475, 53.427],
    [5.477, 53.424],
    [5.48, 53.416],
    [5.482, 53.413],
    [5.469, 53.409],
    [5.427, 53.406],
  ],
  [
    [6.153, 53.469],
    [6.133, 53.454],
    [6.127, 53.46],
    [6.127, 53.463],
    [6.133, 53.468],
    [6.123, 53.482],
    [6.148, 53.495],
    [6.185, 53.505],
    [6.212, 53.509],
    [6.311, 53.514],
    [6.339, 53.509],
    [6.339, 53.502],
    [6.325, 53.502],
    [6.153, 53.469],
  ],
  [
    [4.936, 53.226],
    [4.91, 53.212],
    [4.879, 53.221],
    [4.921, 53.254],
    [4.987, 53.29],
    [5.054, 53.314],
    [5.105, 53.31],
    [5.105, 53.303],
    [5.078, 53.303],
    [5.066, 53.298],
    [5.036, 53.292],
    [4.958, 53.246],
    [4.936, 53.226],
  ],
  [
    [5.914, 53.474],
    [5.955, 53.461],
    [5.856, 53.447],
    [5.753, 53.447],
    [5.727, 53.443],
    [5.679, 53.43],
    [5.654, 53.434],
    [5.636, 53.449],
    [5.642, 53.463],
    [5.659, 53.472],
    [5.674, 53.468],
    [5.914, 53.474],
  ],
  [
    [6.455, 53.558],
    [6.51, 53.544],
    [6.506, 53.544],
    [6.502, 53.543],
    [6.499, 53.54],
    [6.496, 53.536],
    [6.461, 53.543],
    [6.443, 53.55],
    [6.441, 53.557],
    [6.455, 53.558],
  ],
];

/** Watervlakken (IJsselmeer/Markermeer e.a.) — over het land getekend in zeekleur. */
export const NL_WATER: ReadonlyArray<GeoRing> = [
  [
    [5.87, 52.54],
    [5.874, 52.521],
    [5.873, 52.501],
    [5.861, 52.478],
    [5.842, 52.458],
    [5.801, 52.423],
    [5.779, 52.408],
    [5.747, 52.393],
    [5.712, 52.383],
    [5.654, 52.372],
    [5.624, 52.356],
    [5.578, 52.323],
    [5.545, 52.276],
    [5.533, 52.268],
    [5.447, 52.255],
    [5.405, 52.257],
    [5.361, 52.27],
    [5.268, 52.312],
    [5.248, 52.313],
    [5.205, 52.31],
    [5.181, 52.312],
    [5.163, 52.317],
    [5.112, 52.338],
    [5.092, 52.342],
    [5.047, 52.345],
    [5.031, 52.348],
    [4.968, 52.371],
    [4.974, 52.376],
    [4.98, 52.378],
    [4.982, 52.378],
    [4.982, 52.385],
    [4.997, 52.384],
    [5.002, 52.382],
    [5.009, 52.378],
    [5.009, 52.385],
    [5.025, 52.378],
    [5.034, 52.389],
    [5.042, 52.404],
    [5.054, 52.412],
    [5.065, 52.414],
    [5.075, 52.42],
    [5.085, 52.429],
    [5.092, 52.439],
    [5.076, 52.444],
    [5.068, 52.453],
    [5.062, 52.461],
    [5.05, 52.467],
    [5.07, 52.473],
    [5.078, 52.473],
    [5.074, 52.484],
    [5.071, 52.488],
    [5.091, 52.501],
    [5.083, 52.526],
    [5.05, 52.57],
    [5.036, 52.6],
    [5.035, 52.625],
    [5.05, 52.642],
    [5.085, 52.645],
    [5.112, 52.639],
    [5.119, 52.636],
    [5.137, 52.625],
    [5.151, 52.627],
    [5.166, 52.63],
    [5.227, 52.653],
    [5.243, 52.665],
    [5.256, 52.689],
    [5.271, 52.697],
    [5.304, 52.707],
    [5.301, 52.717],
    [5.298, 52.731],
    [5.294, 52.743],
    [5.287, 52.748],
    [5.236, 52.762],
    [5.22, 52.763],
    [5.206, 52.762],
    [5.195, 52.758],
    [5.184, 52.752],
    [5.17, 52.746],
    [5.158, 52.75],
    [5.147, 52.758],
    [5.137, 52.762],
    [5.123, 52.775],
    [5.12, 52.839],
    [5.115, 52.861],
    [5.065, 52.923],
    [5.044, 52.934],
    [5.086, 52.944],
    [5.129, 52.96],
    [5.288, 53.045],
    [5.372, 53.077],
    [5.383, 53.055],
    [5.39, 53.046],
    [5.4, 53.036],
    [5.409, 53.032],
    [5.414, 53.02],
    [5.413, 53.007],
    [5.406, 52.995],
    [5.416, 52.984],
    [5.42, 52.968],
    [5.416, 52.952],
    [5.4, 52.94],
    [5.413, 52.924],
    [5.404, 52.916],
    [5.388, 52.911],
    [5.377, 52.899],
    [5.371, 52.898],
    [5.366, 52.895],
    [5.366, 52.885],
    [5.369, 52.879],
    [5.375, 52.876],
    [5.383, 52.873],
    [5.389, 52.868],
    [5.411, 52.857],
    [5.442, 52.852],
    [5.506, 52.851],
    [5.519, 52.849],
    [5.542, 52.839],
    [5.557, 52.837],
    [5.574, 52.838],
    [5.584, 52.842],
    [5.606, 52.851],
    [5.622, 52.854],
    [5.638, 52.855],
    [5.71, 52.842],
    [5.722, 52.837],
    [5.686, 52.833],
    [5.656, 52.82],
    [5.632, 52.8],
    [5.612, 52.775],
    [5.603, 52.75],
    [5.596, 52.709],
    [5.598, 52.67],
    [5.616, 52.652],
    [5.628, 52.646],
    [5.652, 52.619],
    [5.66, 52.612],
    [5.677, 52.609],
    [5.809, 52.613],
    [5.827, 52.61],
    [5.841, 52.604],
    [5.851, 52.593],
    [5.858, 52.577],
    [5.87, 52.54],
  ],
  [
    [6.219, 53.364],
    [6.247, 53.361],
    [6.263, 53.352],
    [6.251, 53.342],
    [6.219, 53.34],
    [6.153, 53.344],
    [6.147, 53.355],
    [6.15, 53.363],
    [6.157, 53.372],
    [6.168, 53.401],
    [6.185, 53.407],
    [6.207, 53.403],
    [6.229, 53.393],
    [6.221, 53.387],
    [6.212, 53.385],
    [6.203, 53.387],
    [6.195, 53.393],
    [6.196, 53.371],
    [6.219, 53.364],
  ],
  [
    [5.484, 52.928],
    [5.505, 52.946],
    [5.542, 52.959],
    [5.572, 52.967],
    [5.599, 52.973],
    [5.618, 52.971],
    [5.609, 52.959],
    [5.583, 52.95],
    [5.558, 52.944],
    [5.534, 52.937],
    [5.506, 52.927],
    [5.496, 52.916],
    [5.496, 52.906],
    [5.485, 52.9],
    [5.48, 52.911],
    [5.482, 52.922],
    [5.484, 52.928],
  ],
  [
    [5.757, 52.882],
    [5.748, 52.889],
    [5.753, 52.898],
    [5.768, 52.911],
    [5.803, 52.922],
    [5.838, 52.918],
    [5.844, 52.903],
    [5.83, 52.889],
    [5.79, 52.884],
    [5.763, 52.882],
    [5.757, 52.882],
  ],
];
